import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { Link } from 'react-router-dom';
import { Zap, Droplets, Wrench, ArrowRight, Phone } from 'lucide-react';

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      icon: <Zap size={60} className="text-orange" />,
      title: 'Klima Servisi',
      slug: 'klima-servisi',
      description: 'Tüm klima türlerinde montaj, bakım, arıza onarım, gaz dolumu ve performans artırma hizmetleri sunuyoruz.',
      features: [
        'Klima montaj ve demontaj',
        'Periyodik bakım hizmetleri',
        'Arıza tespit ve onarım',
        'Gaz dolumu ve kontrol',
        'Filtre temizliği',
        'Klima gaz kaçak tespiti',
        'Elektronik kart onarımı',
      ],
      image: '/klima.png',
    },
    {
      icon: <Droplets size={60} className="text-orange" />,
      title: 'Kombi Servisi',
      slug: 'kombi-servisi',
      description: 'Kombi bakım, arıza onarım, parça değişimi ve ısıtma performansını artırmaya yönelik profesyonel servis hizmetleri sunuyoruz.',
      features: [
        'Yıllık kombi bakımı',
        'Arıza tespit ve tamir',
        'Petek temizliği',
        'Gaz kaçağı kontrolü',
        'Yedek parça değişimi',
        'Fan ve pompa arıza onarımı',
      ],
      image: '/kombi.png',
    },
    {
      icon: <Wrench size={60} className="text-orange" />,
      title: 'Beyaz Eşya Servisi',
      slug: 'beyaz-esya-servisi',
      description: 'Çamaşır makinesi, bulaşık makinesi, buzdolabı, fırın ve ankastre ürünlerde profesyonel arıza tespit ve onarım hizmetleri sunuyoruz.',
      features: [
        'Çamaşır makinesi tamiri',
        'Bulaşık makinesi servisi',
        'Buzdolabı onarım',
        'Fırın ve ocak tamiri',
        'Tüm markalarda hizmet',
        'Elektronik kart tamiri',
        'Motor ve pompa değişimi',
      ],
      image: '/beyaz-esya.png',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Hizmetlerimiz | Aden İklimlendirme İzmir Teknik Servis</title>
        <meta
          name="description"
          content="Aden İklimlendirme, İzmir genelinde klima, kombi ve beyaz eşya teknik servis hizmetleri sunar. 7/24 servis, aynı gün müdahale ve garantili onarım çözümleri."
        />
      </Helmet>

      <Navbar />

      <section className="py-20 md:py-32 bg-light" data-testid="services-page">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-navy mb-4">
              Hizmetlerimiz
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              İzmir genelinde klima, kombi ve beyaz eşya cihazlarınız için 7/24 teknik servis, bakım ve onarım hizmetleri sunuyoruz. Uzman ekibimizle hızlı arıza tespiti ve kalıcı çözüm sağlıyoruz.
            </p>
          </div>
          <div className="text-center mt-20 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-navy mb-4">
              Neden Aden İklimlendirme?
            </h3>
            <p className="text-slate-700 leading-relaxed">
              15 yıllık saha tecrübesi, 7/24 servis desteği ve garantili işçilik anlayışımızla İzmir genelinde güvenilir teknik servis hizmeti sunuyoruz.
              Arıza tespitinden onarım sürecine kadar her aşamada şeffaf ve kalıcı çözümler üretiyoruz.
            </p>
          </div>


          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={index}
                data-testid={`service-detail-${service.slug}`}
                className={`grid md:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''
                  }`}
              >
                <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                  <div className="mb-4">{service.icon}</div>
                  <h2 className="text-3xl font-bold text-navy mb-4">{service.title}</h2>
                  <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-3 mb-8">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <ArrowRight size={20} className="text-orange mt-1 flex-shrink-0" />
                        <span className="text-slate-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={`/hizmetler/${service.slug}`}
                    data-testid={`service-detail-link-${service.slug}`}
                    className="btn-primary inline-flex items-center"
                  >
                    Detaylı Bilgi
                    <ArrowRight className="ml-2" size={20} />
                  </Link>
                  <a
                    href="tel:+905063853685"
                    className="btn-secondary inline-flex items-center ml-4"
                  >
                    Hemen Ara
                  </a>

                </div>
                <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                  <img
                    src={"/images/hizmetler" + service.image}
                    alt={service.title}
                    className="rounded-lg shadow-lg w-full"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ServicesPage;
